import axios from 'axios';
import { useCallback, useMemo, useState } from 'react';
import Form from '../../../../../components/Form';
import { ControlItem } from '../../../types';
import { formatParam } from '../../helpers';

import ServicePaths from '../../../../../bridge/utils/ServicePaths';

const CreateUserForm = () => {
  const [userId, setUserId] = useState<string | undefined>();
  const [email, setEmail] = useState<string | undefined>();
  const [password, setPassword] = useState<string | undefined>();
  const [formMessage, setFormMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = useCallback(async () => {
    setIsLoading(true);

    const { data } = await axios({
      method: 'POST',
      url: ServicePaths.CONTROL.AddUser,
      params: {
        userId: formatParam(userId),
        email: formatParam(email),
        password: formatParam(password),
      },
    });

    setIsLoading(false);
    setFormMessage(data);
  }, [password, userId, email]);

  const config = useMemo(() => {
    return {
      title: ControlItem.CreateUser,
      formMessage,
      fields: [
        {
          label: 'User Id',
          value: userId,
          handleValueChange: setUserId,
        },
        {
          label: 'Email',
          value: email,
          handleValueChange: setEmail,
        },
        {
          label: 'Password',
          value: password,
          handleValueChange: setPassword,
        },
      ],
      handleSubmit,
      isLoading,
    };
  }, [email, formMessage, handleSubmit, isLoading, password, userId]);

  return <Form config={config} />;
};

export default CreateUserForm;
